export default "__VITE_ASSET__CrijLMSb__"